<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">


.page {
  background-color: #fff;
  border-radius: 12px;
  padding: 20px 15px;
  margin: 10px;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.flex-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.mg-t-10 {
  margin-top: 10px;
}
.mg-b-10 {
  margin-bottom: 10px;
}
.mg-b-20 {
  margin-bottom: 20px;
}
.mg-t-20 {
  margin-top: 20px;
}
.flex {
  display: flex;
  align-items: center;
}
.input_title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  box-sizing: border-box;
  white-space: nowrap;
}
.mg-r-20 {
  margin-right: 20px;
}
.dialog_title {
  font-size: 24px;
}
.input_form {
  width: calc(100% - 300px);
}
.input_form_title {
  font-size: 16px;
  color: #333;
  padding-right: 10px;
  width: 100px;
  text-align: right;
}
.input_form_title_1 {
  width: 100px;
  text-align: right;
  font-size: 16px;
  color: #333;
  padding-right: 10px;
}
.input_form_title_1::before {
  content: "";
  padding-right: 10px;
}
.input_form_title::before {
  content: "*";
  color: red;
  padding-right: 5px;
}
.input_form_w {
  width: 500px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.head_search {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 5px !important;

  .item_warp {
    display: flex;
    margin-top: 5px !important;
    margin-bottom: 5px !important;

    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }

    label {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
      font-weight: 400;
    }
  }
}
.role_heard_tool{
  margin-bottom: 5px !important;
}
::v-deep .el-form-item--mini .el-form-item__content{
  line-height: 16px !important;
}
</style>
